import api from '@/api'

const namespaced = true

const state = {
  bargeReports: [],
  bargeReportFile: null,
  routes: [],
  tugsNames: []
}

const getters = {
  bargeReports: state => state.bargeReports,
  bargeReportFile: state => state.bargeReportFile,
  routes: state => state.routes,
  tugsNames: state => state.tugsNames
}

const mutations = {
  SET_BARGE_REPORTS: (state, payload) => {
    state.bargeReports = payload
  },
  SET_BARGE_REPORT_FILE: (state, payload) => {
    state.bargeReportFile = payload
  },
  SET_TUG_NAMES: (state, payload) => {
    state.tugsNames = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  }
}

const actions = {
  async fetchTugNames({ commit }) {
    try {
      const { data } = await api.getTugsNames()
      if (data.error) {
        commit('SET_TUG_NAMES', [])
        return
      }

      commit('SET_TUG_NAMES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getRoutes()
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchBargeReports({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...payload,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize
      }

      const { data } = await api.getBargeReport(filter)

      if (data.error) {
        commit('SET_BARGE_REPORTS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_BARGE_REPORTS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async downloadBargeReports({ commit }, payload) {
    try {
      const filter = { ...payload }
      const response = await api.downloadBargeReport(filter)

      if (response.data.error) {
        commit('SET_BARGE_REPORT_FILE', null)
        return
      }

      commit('SET_BARGE_REPORT_FILE', response)
    } catch (err) {
      throw err
    }
  },
  resetFile({ commit }) {
    commit('SET_BARGE_REPORT_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
